var exports = {
  "kL": "x7be19a29--4c68a9--container",
  "AS": "x7be19a29--4c68a9--item",
  "QN": "x7be19a29--4c68a9--company",
  "wm": "x7be19a29--4c68a9--logo",
  "Pv": "x7be19a29--4c68a9--letter",
};

module.exports = exports;
